var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefurbishedDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.70404 6.58211C6.56054 6.16166 6.48879 5.71438 6.48879 5.24026C6.48879 2.89649 8.39013 1 10.7399 1C11.4484 1 12.1121 1.16997 12.6951 1.47412L9.92377 4.25623L9.9148 6.09904H11.7713L14.5426 3.33482L14.5516 3.35271C14.8386 3.92524 15 4.56933 15 5.2492C15 7.59297 13.0987 9.48946 10.7489 9.48946C10.3004 9.48946 9.86099 9.41789 9.44843 9.29265L3.73543 15L1 12.2716C3.22756 10.0497 4.47647 8.80398 6.70404 6.58211Z",
    stroke: "#1B2646",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefurbishedDark);
export default __webpack_public_path__ + "static/media/refurbished-dark.255aa1ee5324a61a420828e70956f219.svg";
export { ForwardRef as ReactComponent };